import { ChatPage } from './ChatPage';

document.addEventListener('DOMContentLoaded', function () {
  window.Webflow ||= [];

  window.Webflow.push(async () => {
    const app = new ChatPage();
    app.init();
    document.documentElement.classList.add('webflow-loaded');
  });
});
